// extracted by mini-css-extract-plugin
export default {"footerFlogo":"footer_footerFlogo__oT5X8","footerBlogo":"footer_footerBlogo__NGVp4"};